<div class="product manual-product" (mousedown)="onMouseDown($event)"
  [attr.data-inspecting]="inspecting"
  [attr.data-type]="shelfPosition"
  [attr.data-orientation]="product?.orientation"
  [style]="overlayStyle"
  (click)="inspectProduct($event)"
  (contextmenu)="onProductRightClick($event)">
  <div class="product-content">
    @for (item of (product?.stackHeight || 1) | createRange; track item;) {
      <app-image
        [orientation]="product?.orientation"
        [squeeze]="product?.squeeze"
        [productId]="product?.productId"
        [caseConfig]="product?.caseConfig"
        [thumbnail]="true"
        [style]="productStyle">
      </app-image>
    }
  </div>
</div>
@if (label) {
  <div class="product-label-container">
    <p class="product-label" [style]="labelStyle$ | async">{{label}}</p>
  </div>
}